<template>
  <layout>
    <div>
      <div v-html="invoiceHtml" class="invoice-container"></div>
    </div>
  </layout>
</template>

<script>
import Layout from '@layouts/main'
import { memberMethods, paymentMethods } from '@state/helpers'


export default {
  name: 'Invoice',
  components: {
    Layout,
  },
  props: {
    memberDetails: {
      type: Object,
      default: null,
    },
    paymentDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      email: '',
      invoiceHtml: `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>C4 Fitness Invoice</title>
          <style>
              body {
                  font-family: Arial, sans-serif;
                  margin: 0;
                  padding: 0;
                  background-color: #f7f7f7;
              }
              .container {
                  width: 80%;
                  margin: auto;
                  background-color: #ffffff;
                  padding: 20px;
                  border: 1px solid #dddddd;
                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              }
              .header, .footer {
                  text-align: center;
                  background-color: #ecc22e;
                  color: black;
                  padding: 10px 0;
              }
              .header h1 {
                  margin: 0;
              }
              .invoice-details, .client-details, .payment-details {
                  margin-bottom: 20px;
              }
              .invoice-details h2, .client-details h2, .payment-details h2 {
                  border-bottom: 2px solid #ecc22e;
                  padding-bottom: 5px;
              }
              .details-table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 20px;
              }
              .details-table th, .details-table td {
                  border: 1px solid #dddddd;
                  padding: 8px;
                  text-align: left;
              }
              .details-table th {
                  background-color: #f2f2f2;
              }
              .total {
                  text-align: right;
              }
          </style>
      </head>
      <body>
              <div class="header">
                  <h1>C4 FITNESS</h1>
                  <p>2nd Floor, White Palace Hotel, Sri Lanka</p>
                  <p>Email: c4fitness20@gmail.com | Phone: (076) 257-0888</p>
              </div>
              <div class="invoice-details">
                  <h4>Invoice</h4>
                  <p><strong>Invoice Number:</strong> ${this.paymentDetails.invoice_number}</p>
                  <p><strong>Date:</strong> ${this.paymentDetails.payment_date}</p>
              </div>
              <div class="client-details">
                  <h4>Client Details</h4>
                  <p><strong>Name:</strong> ${this.memberDetails.first_name} ${this.memberDetails.last_name}</p>
                  <p><strong>Address:</strong> ${this.memberDetails.address}</p>
                  <p><strong>Email:</strong> ${this.memberDetails.email}</p>
              </div>
              <div class="payment-details">
                  <h4>Payment Details</h4>
                  <table class="details-table">
                      <thead>
                          <tr>
                              <th>Description</th>
                              <th>Quantity</th>
                              <th>Unit Price</th>
                              <th>Total</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                              <td>Membership</td>
                              <td>1</td>
                              <td>LKR ${this.paymentDetails.payment_details.amount}</td>
                              <td>LKR ${this.paymentDetails.payment_details.amount}</td>
                          </tr>
                      </tbody>
                      <tfoot>
                          <tr>
                              <th colspan="3" class="total">Sub Total</th>
                              <th>LKR ${this.paymentDetails.payment_details.amount}</th>
                          </tr>
                          <tr>
                              <th colspan="3" class="total">Tax</th>
                              <th>LKR 0</th>
                          </tr>
                          <tr>
                              <th colspan="3" class="total">Total</th>
                              <th>LKR ${this.paymentDetails.payment_details.amount}</th>
                          </tr>
                      </tfoot>
                  </table>
              </div>
              <div class="footer">
                  <p>Thank you for your business!</p>
                  <p>If you have any questions about this invoice, please contact us at c4fitness@gmail.com</p>
              </div>
      </body>
      </html>
      `,
    }
  },
  mounted() {
    this.sendEmail()
  },
  methods: {
    ...paymentMethods,
    async sendEmail() {
      debugger
     let obj = {
      emailId : this.memberDetails.email,
      emailTemplate : this.invoiceHtml
     }
    await this.sendEmailToClient({emailDetails:obj})
   },
  },
}
</script>

<style>
.invoice-container {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #dddddd;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
